<template>
  <div>

     <iframe src="https://docs.google.com/document/d/e/2PACX-1vS8bXY1Xn1cvk09-qvUebHaRXQKksdeVUiyux2x9Qs3NJoHQIciKI9sdFvIPSNUrPMu8RNwh8YKxv1K/pub?embedded=true" width="100%" height="650px"></iframe> 

  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>